import $ from "jquery";

import "../../../node_modules/fslightbox/index";
import "./themes/cew/_saisonale-cocktails";

$("body");
